<template>
  <div v-if="step" class="flex items-center gap-3">
    <Datepicker v-model="date" :placeholder="step.title" />
    <TimeInput v-model="time" />
  </div>
</template>

<script setup lang="ts">
import moment from "moment-timezone";
import { ref, watch } from "vue";

import Datepicker from "@/components/Seranova/Datepicker/Datepicker.vue";
import TimeInput from "@/components/Seranova/TimeInput/TimeInput.vue";
import { TimelineStep } from "@/typings/scheduler";

const emit = defineEmits(["update:modelValue"]);
const props = defineProps<{ step: TimelineStep; defaultDate?: string }>();
const date = ref(props.step?.date || props.defaultDate || "");
const time = ref(props.step?.time);

watch(date, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    emitInput();
  }
});
watch(time, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    emitInput();
  }
});
const emitInput = () => {
  if (!date.value || !time.value) return;
  const timeStr = moment(
    date.value + " " + time.value,
    "MM/DD h:m a"
  ).toISOString();
  emit("update:modelValue", { [props.step?.editableFieldName]: timeStr });
};
</script>

<style scoped></style>
